/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import {Component, OnDestroy} from "@angular/core";
import {ICellRendererAngularComp} from "ag-grid-angular";
import { CommonService } from '../../../../shared/services/common.service';

@Component({
    template: `
    <div class="col-md-12 no-padding">
        <div class="access-step-wizard">
            <ol class="access-step-wizard-container" [ngClass]="{'disableStepper': params.data.disableSelection}">
                <li *ngFor="let item of params.value; let i = index" (click)="accessTypeClicked(i, item)" [ngClass]="{'active':params.data.permission.id == item.id, 'selected':item.selected, 'li-over': item.circleMouseOvered}">
                    <a>
                        <span class="circle" (mouseover)="item.circleMouseOvered=true" (mouseout)="item.circleMouseOvered=false"></span>
                    </a>
                </li>
            </ol>
        </div>
    </div>
    `,
    styleUrls: ['./permissions-access-stepper.component.scss']
})
export class PermissionsAccessStepRender implements ICellRendererAngularComp, OnDestroy {
    public params: any;

    constructor(private commonService: CommonService){}

    agInit(params: any): void {
        this.params = params;
        if(this.params.data.permission.id && !this.commonService.fMenu){
            this.retainSelection();
        }
    }

    public accessTypeClicked(curStepIndex: any, item: any) {
        this.params.data.permission.id = item.id;
        this.makePreviousStepsSelected(this.params.value, curStepIndex);
        this.updateParentAccess(this.params.node.parent);
        this.updateChildrensAccess(this.params.node.childrenMapped, item.id, curStepIndex);
        // this.params.context.componentParent.userGroupsForm.form.markAsDirty();
        if(this.params.data.code == 'FMN'){
            this.commonService.fMenu = true;     
        }else{
            this.commonService.fMenu = false;
        }
        this.commonService.sendHierarchy(this.params);  
    }

    private updateParentAccess(parent: any){ /*If atleast one children has the highest access, update the parent access*/
        let highestaccess=0;
        if(parent && parent.data){
            for (const key in parent.childrenMapped) {
                if (parent.childrenMapped.hasOwnProperty(key)) {
                    const element = parent.childrenMapped[key];
                    highestaccess = (element.data.permission.id > highestaccess) ? element.data.permission.id : highestaccess;
                }
            }
            parent.data.permission.id = highestaccess;
            const curStepIndex = this.params.value.findIndex(function(step: any){
                return step.id == highestaccess;
            });
            this.makePreviousStepsSelected(parent.data.accessSteps, curStepIndex);
            this.updateParentAccess(parent.parent);
        }
    }

    private updateChildrensAccess(childrensObj: any, parentAccessId: any, curStepIndex: any){ /* Toggle childrens access based on parets access */
        let childrenNames: any[] = [];
        if(childrensObj && Object.keys(childrensObj).length){
            childrenNames = Object.keys(childrensObj);
        }
        childrenNames.forEach((element, index) => {
            childrensObj[element].data.permission.id = parentAccessId;
            this.makePreviousStepsSelected(childrensObj[element].data.accessSteps, curStepIndex);
            this.updateChildrensAccess(childrensObj[element].childrenMapped, parentAccessId, curStepIndex);
        });
    }

    public retainSelection(){
        const vm = this;
        const curStepIndex = this.params.value.findIndex(function(step: any){
            return step.id == vm.params.data.permission.id;
        });
        this.makePreviousStepsSelected(this.params.value, curStepIndex);
    }

    private makePreviousStepsSelected(steps: any, curIndex: any){
        steps.forEach((element: any, index: any) => {
            (index <= curIndex) ? element.selected = true : element.selected = false;
        });
    }

    ngOnDestroy() {
        this.commonService.fMenu = false;
    }
    
    public refresh(): boolean {
        return false;
    }
}